/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { ModuleCreaGridDto } from './ModuleCreaGridDto';
import {
    ModuleCreaGridDtoFromJSON,
    ModuleCreaGridDtoFromJSONTyped,
    ModuleCreaGridDtoToJSON,
} from './ModuleCreaGridDto';

/**
 * 
 * @export
 * @interface ModuleCreaGridDtoPaginatedResults
 */
export interface ModuleCreaGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ModuleCreaGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ModuleCreaGridDto>}
     * @memberof ModuleCreaGridDtoPaginatedResults
     */
    results?: Array<ModuleCreaGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ModuleCreaGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ModuleCreaGridDtoPaginatedResults interface.
 */
export function instanceOfModuleCreaGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ModuleCreaGridDtoPaginatedResultsFromJSON(json: any): ModuleCreaGridDtoPaginatedResults {
    return ModuleCreaGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ModuleCreaGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModuleCreaGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ModuleCreaGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ModuleCreaGridDtoPaginatedResultsToJSON(value?: ModuleCreaGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ModuleCreaGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

